import { RECEIVE_NOTIFICATIONS, RECEIVE_NOTIFICATION, UPDATE_NOTIFICATION } from '../actions/notification_actions';
import { RECEIVE_USER_NOTIFICATIONS, UPDATE_USER_NOTIFICATIONS_READ, RECEIVE_ALL_NOTIFICATIONS } from '../actions/user_actions';
import _ from "lodash"

  const notifications_reducer = (oldState = {}, action) => {
  Object.freeze(oldState);
  switch(action.type){
    case RECEIVE_NOTIFICATIONS:
      if (!action.notifications) return {};
      return action.notifications
    case RECEIVE_NOTIFICATION:
      return Object.assign({}, oldState, { [action.notification._id]: action.notification })
    case RECEIVE_ALL_NOTIFICATIONS:
      const notifications = _.mapKeys(action.notifications, "_id")
      return { ...oldState, ...notifications }
    case RECEIVE_USER_NOTIFICATIONS:
      const userNotifications = _.mapKeys(action.notifications, "_id")
      let normalizedUserNotifications = { ...oldState, ...userNotifications }
      return normalizedUserNotifications
    case UPDATE_USER_NOTIFICATIONS_READ:
      const updatedNotifications = _.mapKeys(action.notifications, "_id")
      return updatedNotifications
    //Reducer for Profile History Tab
    case UPDATE_NOTIFICATION:
      const historyNotifications = _.mapKeys(action.notifications, "_id")
      // let updateNotification = {...oldState, ...notification}
      return historyNotifications
    default:
      return oldState;
  }
};

export default notifications_reducer;